(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1387],{

/***/ 11387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Footer001": function() { return /* binding */ Footer001; },
  "default": function() { return /* binding */ Footer001_Footer001; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/Footer/index.js + 9 modules
var Footer = __webpack_require__(51712);
// EXTERNAL MODULE: ./src/components/Forms/index.js + 16 modules
var Forms = __webpack_require__(74990);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/components/widgets/footer/Footer001/Banner/Banner.module.scss
var Banner_module = __webpack_require__(43212);
var Banner_module_default = /*#__PURE__*/__webpack_require__.n(Banner_module);
;// CONCATENATED MODULE: ./src/components/widgets/footer/Footer001/Banner/Banner.jsx



var Banner = function(param) {
    var banner = param.banner;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* PageLink */.H_, {
        slug: banner === null || banner === void 0 ? void 0 : (ref = banner.page) === null || ref === void 0 ? void 0 : ref.slug,
        className: (Banner_module_default()).banner,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                image: banner === null || banner === void 0 ? void 0 : (ref1 = banner.preview) === null || ref1 === void 0 ? void 0 : ref1[0],
                className: (Banner_module_default()).image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Banner_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Banner_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading4 */.k8, {
                                color: "light",
                                children: banner === null || banner === void 0 ? void 0 : banner.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Banner_module_default()).arrow,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: (Banner_module_default()).icon,
                                    name: "arrow_right"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                        className: (Banner_module_default()).caption,
                        color: "light",
                        children: banner === null || banner === void 0 ? void 0 : banner.caption
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/footer/Footer001/Banner/index.js


// EXTERNAL MODULE: ./src/components/widgets/footer/Footer001/Footer001.module.scss
var Footer001_module = __webpack_require__(86233);
var Footer001_module_default = /*#__PURE__*/__webpack_require__.n(Footer001_module);
;// CONCATENATED MODULE: ./src/components/widgets/footer/Footer001/Footer001.jsx






var Footer001 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var description = (ref1 = payload === null || payload === void 0 ? void 0 : payload.caption) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var formType = (ref2 = payload === null || payload === void 0 ? void 0 : payload.formType) !== null && ref2 !== void 0 ? ref2 : {};
    var ref3;
    var banners = (ref3 = payload === null || payload === void 0 ? void 0 : payload.banners) !== null && ref3 !== void 0 ? ref3 : [];
    var ref4;
    var template = (ref4 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref4 !== void 0 ? ref4 : "light";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer/* FooterWidgetWrapper */.b, {
        className: (Footer001_module_default())[template],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Footer001_module_default())["text-wrap"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Footer001_module_default()).text,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                            className: (Footer001_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            className: (Footer001_module_default()).description,
                            color: "grey",
                            children: description
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Footer001_module_default()).blocks,
                children: [
                    banners.map(function(banner) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                            banner: banner
                        }, banner.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Footer001_module_default()).subscription,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Forms/* Form */.l0, {
                            item: formType,
                            className: "modified"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Footer001_Footer001 = (Footer001);


/***/ }),

/***/ 43212:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__5Q3Mw","content":"Banner_content__TJXTT","title":"Banner_title__Mwb_0","caption":"Banner_caption__nNGJs","image":"Banner_image__d_Y16","arrow":"Banner_arrow__aaepF"};

/***/ }),

/***/ 86233:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grey":"Footer001_grey__KDOXl","light":"Footer001_light___6YrP","text-wrap":"Footer001_text-wrap__Ws8Qg","text":"Footer001_text__DVdTW","title":"Footer001_title__faKfB","blocks":"Footer001_blocks__wOL14","subscription":"Footer001_subscription__wNbxp"};

/***/ })

}]);